import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import SelectField from './SelectField/SelectField'

const _year = new Date(2016, 1, 1, 12)
const messages = defineMessages({
  month: {
    id: 'forms.month_select',
    defaultMessage: 'Month',
  },
})

const propTypes = {
  intl: PropTypes.object,
  format: PropTypes.oneOf([
    'numeric',
    '2-digit',
    'narrow',
    'short',
    'long',
  ]),
}

const defaultProps = {
  format: 'long',
}

const MonthField = ({ format, intl, ...rest }) => {

  const monthOptions = [...Array(12)].map((x, i) => {
    const month = i + 1
    let monthString = month.toString()
    if (monthString.length < 2) { monthString = `0${monthString}` }
    return {
      label: intl.formatDate(_year.setMonth(i), { month: format }),
      value: monthString,
    }
  })

  return (
    <SelectField
      {...rest}
      options={monthOptions}
      placeholder={intl.formatMessage(messages.month)}
    />
  )
}

MonthField.defaultProps = defaultProps
MonthField.propTypes = propTypes

export default injectIntl(MonthField)
